import { render } from "./WorkBase.vue?vue&type=template&id=895bdc92&scoped=true"
import script from "./WorkBase.vue?vue&type=script&lang=js"
export * from "./WorkBase.vue?vue&type=script&lang=js"

import "./WorkBase.vue?vue&type=style&index=0&id=895bdc92&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895bdc92"]])

export default __exports__